import { IDataSourceItem } from 'Modules/Studio/DataSources/redux/initialState';
import {
  INGESTION_CONSTANTS,
  INGESTION_STATUS_LABELS,
} from '../../../../utilities/Ingestion.constants';
import { IIngestionDataSourceListState } from '../../../IngestionByDataSource/redux/IngestionDataSourceList.slice';
import { TIngestionStatusLabelProps } from '../IngestionStatusLabel';
import {
  RUNNING_ON_TABLES,
  STOPPING_ON_TABLES,
} from '../../../IngestionByDataSource/IngestionByDataSource.constants';
import { IActiveIngestion } from 'Modules/Studio/components/StudioInfo/redux/ingestion.interface';

type TProps = Pick<
  TIngestionStatusLabelProps,
  'activeIngestionTables' | 'latestIngestionLog' | 'mode' | 'status' | 'activeIngestion'
> &
  Pick<IIngestionDataSourceListState, 'view'>;

/**
 * Helpers to get status label when ingestion is happening at table level vs datasource level
 * @param activeIngestion
 * @returns string
 */
const getStatusFromTableIngestion = (activeIngestion: IActiveIngestion | null) => {
  const activeIngestionTables = activeIngestion?.tables || {};
  const activeTables = Object.keys(activeIngestionTables);
  const activeTableCount = activeTables.length;

  // ingestion is happening at the datasource level, return status label at datasource level
  if (activeTableCount === 0) {
    return INGESTION_STATUS_LABELS?.[activeIngestion?.status || -1] || '';
  }

  // check if ALL stopping, return 'Stopping on tables'
  const allTablesAreStopping = activeTables.every((tableName) => {
    const status = activeIngestionTables?.[tableName].status;
    return status === INGESTION_CONSTANTS.TRIGGERED_STOP;
  });

  if (allTablesAreStopping) {
    return STOPPING_ON_TABLES;
  }

  // check if running or stopping, return 'Running on tables'
  const runningOrStoppingOnTables = activeTables.some((tableName) => {
    const status = activeIngestionTables?.[tableName].status;
    return status === INGESTION_CONSTANTS.TRIGGERED_STOP || status === INGESTION_CONSTANTS.RUNNING;
  });

  if (runningOrStoppingOnTables) {
    return RUNNING_ON_TABLES;
  }

  return '';
};

/**
 * gets the appropriate ingestion status, depending on use case
 * @param param0
 * @returns ingestion status string
 */
export const getStatusLabel = ({
  activeIngestionTables,
  latestIngestionLog,
  mode,
  status,
  view,
  activeIngestion,
}: TProps): string => {
  if (
    activeIngestionTables !== undefined &&
    view === 'tables' &&
    mode === 'table' &&
    (latestIngestionLog as IDataSourceItem)?.name in activeIngestionTables
  ) {
    // Ingesting is active at the table level, report the status
    return (
      INGESTION_STATUS_LABELS?.[
        activeIngestionTables?.[(latestIngestionLog as IDataSourceItem)?.name].status
      ] || ''
    );
  } else if (mode === 'TableViewDataSource') {
    // nothing is ingesting
    if (activeIngestion === null) {
      return '';
    }

    return getStatusFromTableIngestion(activeIngestion);
  } else if (view === 'dataSources' && mode === 'DSViewDataSource') {
    // if there are no active ingestions for this datasources AND there is a latest ingestion log with status, report the status
    if (!activeIngestion && latestIngestionLog?.status) {
      return INGESTION_STATUS_LABELS?.[latestIngestionLog?.status] || '';
    }
    if (activeIngestion) {
      return getStatusFromTableIngestion(activeIngestion);
    }
  } else {
    // full ingestion use case

    // nothing to report
    if (!status && !latestIngestionLog?.status) {
      return '';
    }
    // report the status
    return INGESTION_STATUS_LABELS?.[status || latestIngestionLog?.status || -1] || '';
  }
  return '';
};
